import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'division' })

export class DivisionPipe implements PipeTransform {
  transform(dividend: number, divisor: number, significantDigits: number): number {
    let quotient: number = 0;

    if (!dividend || dividend == 0) {
      return quotient;
    }
    quotient = +(dividend / divisor).toFixed(significantDigits);

    return quotient;
  }
}
